import { GetBaseArgs } from "@/lib/baseListOptions";

/**
 * @function ApiClient#GetAsset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAsset(cid, options = {}) {
  return await this._get(`/community/${cid}/asset_list_simple`, options);
}

/**
 * @function ApiClient#GetVendors
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetVendors(cid, options = {}) {
  return await this._get(`/community/${cid}/vendor_list`, options);
}

/**
 * @function ApiClient#GetWorkOrders
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} listOptions
 * @param {any} options = {}
 */
export async function GetWorkOrders(cid, listOptions, options = {}) {
  const args = GetBaseArgs(listOptions);
  const url = Object.keys(args).reduce((acc, value, index) => {
    return acc + (index === 0 ? "?" : "&") + value + args[value];
  }, `/community/${cid}/maintenance/work_orders`);
  return await this._get(url, options);
}

/**
 * @function ApiClient#AddWorkOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} payload
 * @param {any} options = {}
 */
export async function AddWorkOrder(cid, payload, options = {}) {
  return await this._post(`/community/${cid}/maintenance/work_order`, payload, options);
}

/**
 * @function ApiClient#EditWorkOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} payload
 * @param {any} options = {}
 */
export async function EditWorkOrder(cid, id, payload, options = {}) {
  return await this._put(`/community/${cid}/maintenance/work_order/${id || ""}`, payload, options);
}

/**
 * @function ApiClient#DeleteWorkOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function DeleteWorkOrder(cid, id, options = {}) {
  return await this._delete(`/community/${cid}/maintenance/work_order/${id || ""}`, options);
}

/**
 * @function ApiClient#GetWorkOrderSearch
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} keyword = ""
 * @param {any} options = {}
 */
export async function GetWorkOrderSearch(cid, keyword = "", options = {}) {
  return await this._get(`/community/${cid}/maintenance/work_order/search?ss=${keyword || ""}`, options);
}

/**
 * @function ApiClient#GetWorkOrderProcess
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetWorkOrderProcess(cid, id, options = {}) {
  return await this._get(`/community/${cid}/maintenance/work_order/${id || ""}/process/report`, options);
}

/**
 * @function ApiClient#AddProcessWorkOrder
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} payload
 * @param {any} files
 * @param {any} options = {}
 */
export async function AddProcessWorkOrder(cid, id, payload, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(payload));

  if (Array.isArray(files)) {
    files.forEach((file) => formData.append("Image", file));
  }
  return await this._post(`/community/${cid}/maintenance/work_order/${id || ""}/process`, formData, options);
}

/**
 * @function ApiClient#GetWorkOrderRelated
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetWorkOrderRelated(cid, id, options = {}) {
  return await this._get(`/community/${cid}/maintenance/work_order/${id || ""}/related`, options);
}
